import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classNames from 'classnames';
import { connect } from 'react-redux';

// Services
import Person from 'services/data/person';

// Hooks
import { useTriageMutation } from 'modules/triage/hooks/useTriageMutation';

// Components
import SVG from 'components/widgets/icons/svg';


function TransferForm({ call, users, currentUser }) {
  const { transfer } = useTriageMutation({ type: 'call', currentUser });

  const filteredUsers = _.filter(users, Person.isPraece);
  const sortedUsers = _.orderBy(filteredUsers, ['onCall', 'firstName', 'lastName'], ['asc', 'asc', 'asc']);

  function onTransfer(user) {
    call.setOpen(false);

    return transfer({ call, user });
  }

  return (
    <div className="transfer-form">
      <div className="triage-option-form-header triage-option-header" onClick={() => call.setOpen(false)}>
        <SVG src="svg/transfer.svg" className="transfer triage-option-icon" />
        <span>Transfer</span>
        <SVG src="svg/close.svg" className="close-triage-submenu" />
      </div>
      <ul className="triage-option-submenu transfer-submenu">
        {_.map(sortedUsers, user => {
          if (user.id === currentUser.id) return null; // Don't allow transferring to yourself
          return (
            <li
              key={user.id}
              className={classNames({ 'off-call': !user.onCall })}
              onClick={() => onTransfer(user)}
            >
              <SVG
                src={user.onCall ? 'svg/on-call.svg' : 'svg/off-call.svg'}
                className={classNames('margin-right', { 'on-call': user.onCall, 'off-call': user.offCall })}
              />
              {Person.fullName(user)}
            </li>
          );
        })}
      </ul>
    </div>
  );
}

TransferForm.propTypes = {
  call: PropTypes.shape({
    setOpen: PropTypes.func,
    id: PropTypes.number
  }),
  currentUser: PropTypes.object.isRequired,
  users: PropTypes.array
};

export default connect((state) => ({
  currentUser: state.auth.currentUser,
  users: state.pageData.selectUsers
}))(TransferForm);
